import { makeStyles, shorthands } from '@fluentui/react-components';
import { linkGreen } from '../Shared/Shared';

export const useRoleCardStyles = makeStyles({
  main: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    columnGap: '16px',
    rowGap: '36px',
  },

  title: {
    color: '#323130',
    overflowWrap: 'anywhere',
    ...shorthands.margin(0, 0, '8px'),
  },

  subtitle: {
    color: '#323130',
    ...shorthands.margin(0),
  },

  card: {
    width: '315px',
    height: '100%',
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },

  homepageCard: {
    flexBasis: '200px',
    flexGrow: 2,
    width: '100%',
    height: '100%',
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    ...shorthands.padding('0px'),
    ...shorthands.margin('-1px'),
    ...shorthands.overflow('hidden'),
    ...shorthands.border('0px'),
  },
  flex: {
    ...shorthands.gap('4px'),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  caption: {
    ...shorthands.margin(0),
    color: '#605e5c',
    flexGrow: 1,
    overflowWrap: 'anywhere',
  },
  header: {
    marginBottom: 0,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  currentRole: {
    color: 'white',
    backgroundColor: linkGreen,
    ...shorthands.padding('2px', '5px', '2px', '5px'),
    ...shorthands.borderRadius('5px'),
  },
  footer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: '8px',
  },
  divider: {
    maxHeight: '1px !important',
  },
  buttonColor: {
    ':hover': { color: linkGreen },
    ':focus': { color: linkGreen },
  },
  link: {
    color: linkGreen,
    fontSize: '14px',
    fontWeight: 400,
    textDecorationLine: 'underline',
    ':hover': {
      textDecorationLine: 'underline',
    },
    ':focus': {
      textDecorationLine: 'underline',
    },
  },
});
